@if (!holidays || !holidays.length) {
<p class="mat-body-1">No holidays set</p>
} @else { @for (holiday of holidays; track holiday) {
<p class="mat-body-1">
  {{ holiday.label }} - {{ holidayMonths[holiday.m] }} {{ holiday.d }} <br />
</p>
} }
